import type { SiteConfigFn, SiteVsmContext, SiteFeatureConfigResult } from '@wix/thunderbolt-vsm-api-types'
import type { IComponentsRegistrySiteConfig } from '../symbols'

function buildComponentsRegistryConfig(
	{ api, funcLib }: SiteVsmContext,
	experimentalMobileLibraryReactNative = false
): SiteFeatureConfigResult<IComponentsRegistrySiteConfig> {
	const shouldLoad = api.features.isActive('platform')

	if (!shouldLoad) {
		return { shouldLoadSiteFeature: false }
	}

	const serviceTopology = api.rootConfig.getServiceTopology()
	const url = api.originalRequest.getUrl() ?? ''
	const headers = api.originalRequest.getHeaders() || {}
	const componentsOnSite = api.rendererModel.getSiteMetaData()?.renderHints?.componentsCount
	const useNewStatics = api.env.getExperiments()['specs.thunderbolt.useEENewStatics'] === true

	const librariesTopology = funcLib.getRegistryComponentsLibraries({
		originalRequest: { url, headers },
		serviceTopology: serviceTopology || ({} as any),
		componentsOnSite,
		experimentalMobileLibraryReactNative,
		useNewStatics,
	})

	return {
		shouldLoadSiteFeature: true,
		shouldLoadSiteConfig: true,
		siteConfig: {
			librariesTopology,
		},
	}
}

const componentsRegistrySiteConfig: SiteConfigFn<IComponentsRegistrySiteConfig> = (ctx) =>
	buildComponentsRegistryConfig(ctx)

const reactNativeComponentsRegistrySiteConfig: SiteConfigFn<IComponentsRegistrySiteConfig> = (ctx) =>
	buildComponentsRegistryConfig(ctx, true)

const name = 'componentsRegistry'

export const config = {
	site: componentsRegistrySiteConfig,
	reactNativeSite: reactNativeComponentsRegistrySiteConfig,
	name,
}
